import React, { memo } from 'react';
import {useSelector} from 'react-redux';
import {isNormalZhEnCss} from '../../utils';
import 'swiper/css';
import "swiper/css/pagination";
import "swiper/css/navigation";
import styles from './styles.module.scss';

const Index = memo(() => {
  const { home: {entertainment}, lang } = useSelector(({localesReducer}) => localesReducer.i18n);
  // 样式判断
  const normal = () => {
    return isNormalZhEnCss(lang, 'English') ? styles.normalen : styles.normalcn;
  };

  const { leftContent, rightContent } = entertainment;
  return (
      <div className={normal()}>
        <div className='left'>
          <div className='row'>
            <p className='title'>{leftContent.title}</p>
            <p className='subTitle'>{leftContent.subTitle}</p>
            <div className='desc'>
              <span className='text'>{leftContent.desc}</span>
              <svg width="96" height="1" viewBox="0 0 96 1" fill="none" xmlns="http://www.w3.org/2000/svg">
               <line opacity="0.6" y1="0.5" x2="96" y2="0.5" stroke="#3B3B3B"/>
              </svg>
            </div>
          </div>
          <div className='row'>
           {leftContent.list.map(item => (<p key={item.id} className='itemText'>{item.desc}</p>))}
          </div>
        </div>
        <div className='right'>
          {rightContent.textList.map(item => (
            <div key={item.id} className='row'>
              <p className='title'>{item.title}</p>
              <div className='desc'>
                <span className='number'>{item.number}</span>
                {item.desc ? <span className='subText'>{item.desc}</span> : null}
              </div>
            </div>
          ))}
        </div>
      </div>
  );
});
export default Index;
